// import { Entry } from '@Protium/vue-ozone-utils'

import { Country, CountryISO } from './enums'
import { Email, Phone } from './types'
import { UUID } from 'node_modules/@Protium/vue-ozone-utils/types'
import { ComputedRef, Ref } from 'vue'
import { CtTask, TaskType } from './interfaces/content-type'
import { TaskOptions } from '@/composables/useTask'
import { CountryIso } from '@/constants/country_iso_dict'

export type Primitive = string | number | boolean | null | undefined
export type JSPrimitive = string | number | boolean | null | undefined | symbol | bigint

export interface Entry {
  sys: {
    id: UUID
  }
}

export interface Dimensions {
  x?: number
  y?: number
  z?: number
  weight_unit?: MetricWeightUnit
  unit?: MetricLengthUnit
  capacity?: number
}

export enum MetricLength {
  Kilometer = 'kilometer',
  Hectometer = 'hectometer',
  Decameter = 'decameter',
  Meter = 'meter',
  Decimeter = 'decimeter',
  Centimeter = 'centimeter',
  Millimeter = 'millimeter',
  Micrometer = 'micrometer',
  Nanometer = 'nanometer'
}

export enum MetricLengthUnit {
  Kilogram = 'km',
  Hectometer = 'hm',
  Decameter = 'dam',
  Meter = 'm',
  Decimeter = 'dm',
  Centimeter = 'cm',
  Millimeter = 'mm',
  Micrometer = 'μm',
  Nanometer = 'nm'
}

export enum MetricWeightString {
  Kilogram = 'kilogram',
  Hectogram = 'hectogram',
  Dekagram = 'dekagram',
  Gram = 'gram',
  Decigram = 'decigram',
  Centigram = 'centigram',
  Milligram = 'milligram',
  Microgram = 'microgram',
  Nanogram = 'nanogram'
}

export enum MetricWeightUnit {
  Kilogram = 'kg',
  Hectogram = 'hg',
  Dekagram = 'dag',
  Gram = 'g',
  Decigram = 'dg',
  Centigram = 'cg',
  Milligram = 'mg',
  Microgram = 'μg',
  Nanogram = 'ng'
}

export interface SelectOption<V = any> {
  label: string,
  value: V
}

export interface EntryCollection {
  [key:string]: Array<any>
}

export enum Contact {
  Phone= 'phone',
  Name= 'name',
  Email= 'email'
}

// export interface Address {
//   customer?: string
//   company?: string
//   fullname?: string
//   lastname?: string
//   firstname?: string
//   street?: string
//   street_number?: string | number
//   addition?: string
//   formatted?: string
//   address1?: string
//   city?: string
//   zipcode?: string
//   country?: Country | string // this one is hard to type strictly
//   country_iso?: CountryISO
//   email?: Email
//   phone?: Phone
//   department?: string
// }

export interface KeyIndex {
  key: string,
  index: number
}
export interface TreeState {
  id: string,
  data: Record<string, any> | Array<Record<string, any>>,
  keyIndex: Array<KeyIndex>,
  suggestions: Array<SelectOption>
}

export type UniqKey = string & { readonly _: unique symbol }

export type SelectableItem = { [key: string]: UniqKey } & { [key: string]: any }  | { sys: { id: string, [key: string]: any }, [key: string]: any }
export type SelectionDict<K extends string = UniqKey> = Record<K, number | boolean | Record<K, { id: string, value: number }>>

export interface SelectableListState {
  Items: ComputedRef<Array<SelectableItem>>,
  Selection: ComputedRef<SelectionDict>,
  Active: Ref<string | Array<string> | undefined>,
  ActiveTask: ComputedRef<Partial<CtTask>>,
  ActiveItem: Ref<string | undefined>
  Config: {
    type: TaskType,
    options: Partial<TaskOptions>
  }
}

export type SelectableStoreDispatchers = {
  Add (id: string, items: Array<SelectableItem>): Promise<any>,
  // Config(key: string): Promise<any>,
  Remove(id: string, remove: number): Promise<any>,
  Select(id: string, selection:SelectionDict<string>, value?: boolean | number,  toggle?: boolean, evaluator?: (value: any) => boolean): Promise<any>,
  Active(id: string): any,
  ActiveItem(id: string): any,
  Next(input: any): any,
  Complete(id: string | Omit<CtTask, 'sys'>, clear?: boolean, clearDelay?: number): Promise<any>
}

export interface SelectableStore {
  getters: SelectableListState,
  dispatch(action: keyof SelectableStoreDispatchers, ...args: Array<any>): Promise<any> | any
}

export interface Address {
  // customer?: string

  // generic shipping lines support... (for raw maps)
  // address1?: string
  // address2?: string

  company?: string
  fullname?: string
  lastname?: string
  firstname?: string
  street?: string
  street_number?: number
  addition?: string
  formatted?: string
  city?: string
  zipcode?: string
  country?: CountryIso | string // this one is hard to type strictly
  country_iso?: CountryIso
  county?: string
  region?: string
  state?: string
  email?: Email
  phone?: Phone
  department?: string
  /** @description an identification document id */
  document_id?: string

  /** @description generic meta field containing info not fitting the normal model */
  meta?: Record<string, Primitive>

  // NOTE common additional address fields... containing generic data
  // address1?: string
  // address2?: string
}
